export default __webpack_public_path__ + "static/media/UNMISS_tier_i.83785d36.jpg";